import r from "../managers/braze-instance.js";
import HtmlMessage from "./models/html-message.js";
import se from "./in-app-message-manager-factory.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import et from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as ot } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageHtmlClick(e, t, s) {
  if (!r.rr()) return !1;
  if (!(e instanceof HtmlMessage))
    return (
      N.error(
        "inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object.",
      ),
      !1
    );
  let o = d.Li;
  null != t && (o = d.Qi);
  const m = se.ea().ut(e, o, t, s);
  if (m.tt)
    for (let r = 0; r < m.$e.length; r++)
      ot.m().Ce(et.Zr, [e.triggerId, t], m.$e[r]);
  return m.tt;
}
